var shards = {
  na: { languages: ['en_US'], platform: 'NA1' },
  euw: { languages: ['en_GB', 'de_DE', 'fr_FR', 'es_ES', 'it_IT'], platform: 'EUW1' },
  eune: { languages: ['en_PL', 'cs_CZ', 'el_GR', 'hu_HU', 'pl_PL', 'ro_RO'], platform: 'EUN1' },
  br: { languages: ['pt_BR'], platform: 'BR1' },
  tr: { languages: ['tr_TR'], platform: 'TR1' },
  ru: { languages: ['ru_RU'], platform: 'RU' },
  lan: { languages: ['es_MX'], platform: 'LA1' },
  las: { languages: ['es_AR'], platform: 'LA2' },
  oce: { languages: ['en_AU'], platform: 'OC1' },
  jp: { languages: ['ja_JP'], platform: 'JP1' }
};

var languages = Object.keys(shards).map(function(shard) {
  return shards[shard].languages.map(function(locale) {
    return {
      shard: shard,
      locale: locale,
      language: locale.split('_')[0]
    }
  });
}).reduce(function(langs, newLangs) {
  return langs.concat(newLangs);
}, []);

var shardPlatform = function(shard) {
  return shards[shard].platform;
}

var platformShard = function(platform) {
  return Object.keys(shards).find(function(shard) {
    return shards[shard].platform === platform;
  });
}

var localeShard = function(locale) {
  return Object.keys(shards).find(function(shard) {
    if(shards[shard].languages.indexOf(locale) >= 0) {
      return shard;
    } else {
      return false;
    }
  });
}

module.exports = {
  shards: shards,
  languages: languages,
  shardPlatform: shardPlatform,
  platformShard: platformShard,
  localeShard: localeShard,
  defaultShard: 'na'
};



//////////////////
// WEBPACK FOOTER
// ./config/riot_regions.js
// module id = 316
// module chunks = 39